import { defineAsyncComponent } from 'vue'
export default {
  account: defineAsyncComponent(() => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/layouts/account.vue")),
  blank: defineAsyncComponent(() => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/layouts/blank.vue")),
  default: defineAsyncComponent(() => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/layouts/default.vue")),
  search: defineAsyncComponent(() => import("/var/www_vsf/releases/70dbdf7b-aa7d-4805-b46a-8faef61a0aff/layouts/search.vue"))
}